import { useCallback } from 'react';
import { useAsyncFetcher } from 'reporting-data/asyncData/useAsyncFetcher';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { getAIReportRemixes } from '../api/openAI';
const useFetchReportRemixes = ({
  report,
  deferred,
  numberOfRemixes = 3
}) => {
  const fetcher = useCallback(() => getAIReportRemixes(report.toJS(), numberOfRemixes), [numberOfRemixes, report]);
  // Used for testing purposes
  // const fetcher = useCallback(() => FAKE_RESPONSE, []);

  return useAsyncFetcher({
    fetcher,
    deferred: deferred || !isConfigReport(report)
  });
};
export default useFetchReportRemixes;